<template>
  <div
    class="bk-card"
    @click="onCardClick"
    style="cursor: pointer;"
  >
    <!-- Cover + Overlay Badges -->
    <div class="bk-cover-wrap">
      <img
        :src="coverUrl"
        :alt="bookName"
        class="bk-cover-img"
        @error="onImageError"
      />
      <!-- Top-left Badges: HOT + Condition + Status + Ownership -->
      <div class="bk-badges-top-left">
        <span v-if="isHot" class="bk-badge-hot">
          <icon icon="fa-solid fa-arrow-trend-up" />HOT
        </span>
        <span v-if="perStatusText" class="bk-badge-per">
          {{ perStatusText }}
        </span>
        <span v-if="verStatusText" class="bk-badge-cond">
          {{ verStatusText }}
        </span>
        <span v-if="hasReadingStatus" :class="['bk-badge-status', getStatusBadgeClass(progressStatus)]">
          <span class="dot-live"></span>
          <span>{{ getStatusLabel(progressStatus) }}</span>
        </span>
        <span v-if="hasOwnership" :class="['bk-own-tag', getOwnStatusBadgeClass(ownStatus)]">
          <icon :icon="getOwnStatusIcon(ownStatus)" class="bk-own-icon" />
          <span>{{ getOwnStatusLabel(ownStatus) }}</span>
        </span>
      </div>

      <!-- Rating top-right: User rating in bookcase mode, Book rating in catalog mode -->
      <span v-if="isBookcaseMode && myEvaluate > 0" class="bk-badge-rating">
        Bạn: {{ '★'.repeat(myEvaluate) }}
      </span>
      <span v-else class="bk-badge-rating">
        ★ {{ communityEvaluate.toFixed(1) }}
      </span>
    </div>

    <!-- Info Block -->
    <div class="bk-info">
      <!-- Title -->
      <router-link :to="detailRoute" class="bk-title text-decoration-none" @click.stop>
        {{ bookName }}
      </router-link>

      <!-- Author -->
      <p v-if="hasAuthors" class="bk-author">
        <icon icon="fa-solid fa-feather-pointed" class="me-1 opacity-75" />
        <template v-if="authorsList.length > 0">
          <template v-for="(author, idx) in authorsList" :key="author.id || author.name || idx">
            <span class="bk-tag-link" @click.stop="goSearchAuthor(author)">{{ author.name }}</span>
            <span v-if="idx < authorsList.length - 1">, </span>
          </template>
        </template>
        <span v-else class="bk-tag-link" @click.stop="goSearchAuthor(authorsStr)">{{ authorsStr }}</span>
      </p>

      <!-- Seller / Creator (for old books) -->
      <p v-if="creatorName" class="bk-author" style="color: #64748b;">
        <icon icon="fa-solid fa-user" class="me-1 opacity-75" />
        <span style="font-weight: 400;">Người bán:</span> {{ creatorName }}
      </p>

      <!-- Translator -->
      <p v-if="translatorsStr" class="bk-author" style="color:#8896ab">
        <icon icon="fa-solid fa-language" class="me-1 opacity-75" />
        {{ translatorsStr }}
      </p>

      <!-- Categories -->
      <div v-if="hasCategories" class="bk-categories-line">
        <icon icon="fa-solid fa-tag" class="me-1 opacity-75" />
        <template v-if="categoriesList.length > 0">
          <template v-for="(cat, idx) in categoriesList" :key="cat.id || cat.name || idx">
            <span class="bk-tag-link" @click.stop="goSearchCategory(cat)">{{ cat.name }}</span>
            <span v-if="idx < categoriesList.length - 1">, </span>
          </template>
        </template>
        <span v-else class="bk-tag-link" @click.stop="goSearchCategory(categoriesStr)">{{ categoriesStr }}</span>
      </div>

      <!-- Price for Old Books -->
      <div v-if="priceFormatted" class="bk-price-line mt-1">
        <span class="bk-price-tag">{{ priceFormatted }}</span>
      </div>

      <!-- Note line -->
      <div v-if="isValidNote(note)" class="bk-note-line mb-1">
        <icon icon="fa-solid fa-note-sticky" class="bk-note-icon" />
        <strong class="bk-note-label">Note:</strong>
        <span class="bk-note-text">{{ note }}</span>
        <button
          v-if="isLongNoteGrid(note)"
          type="button"
          class="bk-note-more"
          @click.stop="onViewNoteClick"
        >Xem thêm</button>
      </div>

      <!-- Progress -->
      <div v-if="hasProgress" class="bk-progress-wrap mt-auto pt-2">
        <div class="bk-progress-bar-bg">
          <div
            class="bk-progress-bar-fill"
            :class="getProgressBarClass(progressStatus)"
            :style="{ width: calculateVisualPercent() + '%' }"
          ></div>
        </div>
        <span :class="['bk-progress-text', getProgressTextClass(progressStatus)]">{{ formatProgressText() }}</span>
      </div>
    </div>

    <!-- Footer Action (only in bookcase mode) -->
    <div v-if="isBookcaseMode" class="bk-footer" @click.stop>
      <button type="button" class="bk-btn-update me-2" @click.stop="onUpdateClick">
        <icon icon="fa-solid fa-pen-to-square" />
        <span>Cập nhật</span>
      </button>
      <button type="button" class="bk-btn-delete" title="Xóa khỏi tủ sách" @click.stop="onDeleteClick">
        <icon icon="fa-solid fa-trash-can" />
      </button>
    </div>
  </div>
</template>

<script src="./BookCard.js"></script>
<style scoped src="./BookCard.css"></style>
